'use strict';

const Reflux = require('@muzzylane/reflux');
const find = require('lodash/find');
const maxBy = require('lodash/maxBy');
const filter = require('lodash/filter');
const sortBy = require('lodash/sortBy');
const keys = require('lodash/keys');
const sum = require('lodash/sum');
const map = require('lodash/map');
const forEach = require('lodash/forEach');
const isObject = require('lodash/isObject');
const assign = require('lodash/assign');
const compact = require('lodash/compact');
const has = require('lodash/has');
const get = require('lodash/get');

const AccountActions = require('../actions/AccountActions');
const AssignmentActions = require('../actions/AssignmentActions');
const ServerRequest = require('../actions/request');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');
const Globals = require('../../../app/globals');
const StringUtil = require('../../../app/shared/StringUtil');
const InitPendo = require('../util/InitPendo');

let assignments = {};
let assignmentActivities = {};
let assignmentWeights = {};
let assignmentMetaOptions = {};
let assignmentLtiDiagnostics = {};
let userAssignments = { loading: false };
let userAssignmentStudentCounts = { loading: false };
let newActID = null;
let userAttemptHistories = {};
let adminSendScoreErrors = null;

let initialized = false;
let action = {};
let error = null;
let loggedOutOfAssignment = false;

const AssignmentStore = Reflux.createStore({
    listenables: [AssignmentActions,SignInActions,AccountActions],
    init: function() {return},

    resetState: function() {
        assignments = {};
        userAssignments = { loading: false };
        newActID = null;
        initialized = false;
        loggedOutOfAssignment = false; // true if we can't get assignment info because the user is logged out
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },


    //TODO: wait for SignedInStore.initialized
    getState: function() {
        return {
            initialized: initialized,
            assignmentsData: assignments,
            assignmentActivities: assignmentActivities,
            assignmentWeights: assignmentWeights,
            assignmentMetaOptions: assignmentMetaOptions,
            assignmentLtiDiagnostics: assignmentLtiDiagnostics,
            userAssignments: userAssignments,
            loggedOutOfAssignment: loggedOutOfAssignment,
            userAssignmentStudentCounts: userAssignmentStudentCounts,
            userAttemptHistories: userAttemptHistories,
            adminSendScoreErrors: adminSendScoreErrors,
            error: error,
            action: action
        }
    },

    getStateAssignment: function(assignmentHash) {
        return {
            initialized: initialized,
            assignmentData: assignments[assignmentHash],
            assignmentActivity: assignmentActivities[assignmentHash],
            assignmentWeights: assignmentWeights[assignmentHash] || [],
            assignmentMetaOptions: assignmentMetaOptions[assignmentHash] || {},
            assignmentLtiDiagnostics: assignmentLtiDiagnostics[assignmentHash],
            userAttemptHistories: userAttemptHistories,
            adminSendScoreErrors: adminSendScoreErrors,
            loggedOutOfAssignment: loggedOutOfAssignment,
            error: error,
            action: action
        }
    },

    getNumAttemptsForStudentAssignment: function(assignmentHash, studentId) {
        return this.getAttemptsForStudentAssignment(assignmentHash, studentId).length;
    },

    getAttemptsForStudentAssignment: function(assignmentHash, studentId) {
        if(!assignments[assignmentHash]) {
            console.warn("getAttemptsForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return [];
        }

        // common case where student exists but has not started an attempt
        if(!assignments[assignmentHash]["attempts"][studentId]) {
             // console.warn("getAttemptsForStudentAssignment: Student " + studentId + " not found in assignment " + assignmentHash);
            return [];
        }

        return assignments[assignmentHash]["attempts"][studentId];
        // return filter(assignments[assignmentHash].stats, {user_id: studentId});
    },

    getAttemptForStudentAssignment: function(assignmentHash, studentId, attemptId) {
        let attempts = this.getAttemptsForStudentAssignment(assignmentHash, studentId);

        let attempt = find(attempts, {id: attemptId})
        if(!attempt) {
            console.warn("getAttemptForStudentAssignment: Attempt " + attemptId + " not found in store.");

            return {};
        }

        return attempt;
    },

    getLatestCompletedAttemptForStudentAssignment: function(assignmentHash, studentId) {
        if(!assignments[assignmentHash]) {
            console.warn("getAttemptsForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return null;
        }

        // common case where student exists but has not started an attempt
        if(!assignments[assignmentHash]["attempts"][studentId]) {
            return null;
        }

        return maxBy(filter(assignments[assignmentHash]["attempts"][studentId], { user_status: Globals.attempt.user_statuses.COMPLETE }), 'attempt');
    },

    getActiveAttemptForStudentAssignment: function(assignmentHash, studentId) {
        if(!assignments[assignmentHash]) {
            console.warn("getActiveAttemptForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        if(!assignments[assignmentHash]["activeAttempts"][studentId]) {
             // console.warn("getActiveAttemptForStudentAssignment: Student " + studentId + " not found in assignment " + assignmentHash);
            return {};
        }

        return assignments[assignmentHash]["activeAttempts"][studentId];
    },

    getScoresForStudentAssignment: function(assignmentHash, studentId) {
        if(!assignments[assignmentHash]) {
            console.warn("getScoresForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return [];
        }

        return filter(assignments[assignmentHash].scores_and_times, {user_id: studentId});
    },

    getScoresCategoriesForAssignment: function(assignmentHash, sorted) {
        if(!assignments[assignmentHash]) {
            console.warn("getScoresCategoriesForAssignment: Assignment " + assignmentHash + " not found in store.");
            return [];
        }

        if(!assignments[assignmentHash].scAnalytics || !assignments[assignmentHash].scAnalytics.scoreCategories) {
             console.warn("getScoresCategoriesForAssignment: Assignment " + assignmentHash + " scAnalytics not found in store.");
            return [];
        }

        if(sorted) {
            // LODASH_UPDATE sortBy -> orderBy
            return sortBy(assignments[assignmentHash].scAnalytics.scoreCategories, (cat) => {return parseInt(cat.id, 10)});
        }
        else {
            return assignments[assignmentHash].scAnalytics.scoreCategories;
        }
    },

    getScoresCategoriesForAssignmentByName: function(assignmentHash, sorted, assnActId=null) {
        if (!assignments[assignmentHash]) {
            console.warn(`getScoresCategoriesForAssignmentByName: Assignment ${assignmentHash} not found in store.`);
            return [];
        }

        let scoreCategories;
        if (!assnActId) {
            if (
                !assignments[assignmentHash].scAnalytics
                || !assignments[assignmentHash].scAnalytics.scoreCategoriesByName
            ) {
                console.warn(`getScoresCategoriesForAssignmentByName: Assignment ${assignmentHash} scAnalytics not found in store.`);
                return [];
            }

            scoreCategories = assignments[assignmentHash].scAnalytics.scoreCategoriesByName;
        }
        else {
            if (
                !assignments[assignmentHash].scAnalytics
                || !assignments[assignmentHash].scAnalytics
                || !assignments[assignmentHash].scAnalytics[assnActId]
                || !assignments[assignmentHash].scAnalytics[assnActId].scoreCategoriesByName
            ) {
                console.warn(`getScoresCategoriesForAssignmentByName: Assignment ${assignmentHash}, assnActId ${assnActId} scAnalytics not found in store.`);
                return [];
            }

            scoreCategories = assignments[assignmentHash].scAnalytics[assnActId].scoreCategoriesByName;
        }

        if (sorted === 'id') {
            return sortBy(scoreCategories, cat => cat.id);
        }
        else if (sorted) {
            return sortBy(scoreCategories, cat => cat.name);
        }
        else {
            return scoreCategories;
        }
    },

    getScoreCategoryRangesForAssignment: function(assignmentHash) {
        if (!assignments[assignmentHash]) {
            console.warn("getScoreCategoryRangesForAssignment: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        if (!assignments[assignmentHash].scAnalytics || !assignments[assignmentHash].scAnalytics.scoreCategoryRanges) {
             console.warn("getScoreCategoryRangesForAssignment: Assignment " + assignmentHash + " scoreCategoryRanges not found in store.");
            return {};
        }

        return assignments[assignmentHash].scAnalytics.scoreCategoryRanges;
    },

    getScoreCategoryRangesForAssignmentByName: function(assignmentHash) {
        if (!assignments[assignmentHash]) {
            console.warn(`getScoreCategoryRangesForAssignmentByName: Assignment ${assignmentHash} not found in store.`);
            return {};
        }

        if (
            !assignments[assignmentHash].scAnalytics
            || !assignments[assignmentHash].scAnalytics.scoreCategoryRangesByName
        ) {
             console.warn(`getScoreCategoryRangesForAssignmentByName: Assignment ${assignmentHash} scoreCategoryRanges not found in store.`);
            return {};
        }

        return assignments[assignmentHash].scAnalytics.scoreCategoryRangesByName;
    },

    // note returned object may be an object of format: { missing_data: true/false, opt_out: true/false }
    getScoreCategoryTotalsForActInstUser: function(assignmentHash, actInstId, userHash, assnActId=null) {
        if (!assignments[assignmentHash]) {
            console.warn("getScoreCategoryTotalsForActInstUser: Assignment " + assignmentHash + " not found in store.");
            return { flags: { missing_data: true } };
        }

        if (!assnActId) {
            if (
                !assignments[assignmentHash].scAnalytics
                || !assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser
                || !assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser[userHash]
                || !assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser[userHash][actInstId]
            ) {
                // console.warn("getScoreCategoryTotalsForActInstUser: Assignment " + assignmentHash + " scAnalytics not found in store.");
                return { flags: { missing_data: true } };
            }

            return assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser[userHash][actInstId];
        }
        else {
            if (
                !assignments[assignmentHash].scAnalytics
                || !assignments[assignmentHash].scAnalytics[assnActId]
                || !assignments[assignmentHash].scAnalytics[assnActId].scoreCategoryTotalsByUser
                || !assignments[assignmentHash].scAnalytics[assnActId].scoreCategoryTotalsByUser[userHash]
                || !assignments[assignmentHash].scAnalytics[assnActId].scoreCategoryTotalsByUser[userHash][actInstId]
            ) {
                // console.warn(`getScoreCategoryTotalsForActInstUser: Assignment ${assignmentHash} assnActId ${assnActId} scAnalytics not found in store.`);
                return { flags: { missing_data: true } };
            }

            return assignments[assignmentHash].scAnalytics[assnActId].scoreCategoryTotalsByUser[userHash][actInstId]
        }
    },

    getScoreCategoryTotalsForActInstsUser: function(assignmentHash, actInstIds, userHash) {
        if (!assignments[assignmentHash]) {
            console.warn(`getScoreCategoryTotalsForActInstsUser: Assignment ${assignmentHash} not found in store.`);
            return [];
        }

        if (
            !assignments[assignmentHash].scAnalytics
            || !assignments[assignmentHash].scAnalytics.scoreCategoryTotals
            || !assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser[userHash]
        ) {
            // common warning from users without detailed analytics, called from getScoreForStudentAssignment
            // console.warn("getScoresCategoriesForAssignment: Assignment " + assignmentHash + " scAnalytics not found in store.");
            return [];
        }

        let scTotals = {};
        actInstIds.forEach((actInstId) => {
            const totalsForActInst = assignments[assignmentHash].scAnalytics.scoreCategoryTotalsByUser[userHash][actInstId];
            if (totalsForActInst) {
                keys(totalsForActInst).forEach((scId) => {
                    if (!scTotals[scId]) scTotals[scId] = [];
                    if (totalsForActInst[scId].missing_data || totalsForActInst[scId].opt_out) return;
                    scTotals[scId].push(totalsForActInst[scId]);
                });
            }
        })

        return scTotals;
    },


    //decide which attempt to use based on assignment.score_type and sum time_played across attempts
    getScoreForStudentAssignment: function(assignmentHash, studentId, studentHash) {
        function _getTotalTimePlayed(attempts) {
            return sum(map(attempts, a => a.time_played));
        }

        function _getAvgScore(attempts) {
            return Math.round(sum(map(attempts, a => a.score)) / attempts.length)
        }

        function _getAvgScTotals(scTotals) {
            const avgScTotals = { flags: {} }; // ignore missing_data or opt_out instances when generating average
            Object.keys(scTotals).forEach((scName) => {
                if (scName === 'flags') return;

                avgScTotals[scName] = {
                    sc_name: scName, // added extra props to satisfy StudentReportTableCell required props
                    nova_act_inst_id: 'average', // ...
                    user_hash: studentHash, // ...
                    max_score: Math.round(sum(scTotals[scName].map(tot => tot.max_score || 0)) / scTotals[scName].length),
                    score: Math.round(sum(scTotals[scName].map(tot => tot.score)) / scTotals[scName].length),
                };
            });

            return avgScTotals;
        }

        const assignmentData = assignments[assignmentHash];
        if (!assignmentData) {
            console.warn(`getAttemptForStudentAssignment: Assignment ${assignmentHash} not found in store.`);
            return {};
        }

        const studentScores = this.getScoresForStudentAssignment(assignmentHash, studentId);
        //no attempts completed
        if (studentScores.length === 0) {
            const activeAttempt = this.getActiveAttemptForStudentAssignment(assignmentHash, studentId);
            return {
                completed: false,
                hasntStarted: activeAttempt.user_status === Globals.attempt.user_statuses.NEW,
                inprogress: [Globals.attempt.user_statuses.STARTED, Globals.attempt.user_statuses.IN_PROGRESS].indexOf(activeAttempt.user_status) >= 0,
                user_status: activeAttempt.user_status,
                score: 0,
                time_played: 0
            };
        }

        // for testing
        // assignmentData.assignment.score_type = Globals.assignment.score_types.HIGHEST;
        // assignmentData.assignment.score_type = Globals.assignment.score_types.LATEST;
        // assignmentData.assignment.score_type = Globals.assignment.score_types.AVG;
        // assignmentData.assignment.score_type = Globals.assignment.score_types.LOWEST;

       let useAttempt;
       let attemptInfo;
        switch (assignmentData.assignment.score_type) {
            case Globals.assignment.score_types.HIGHEST: {
                useAttempt = maxBy(studentScores, attempt => attempt.score);
                attemptInfo = this.getAttemptForStudentAssignment(assignmentHash, useAttempt.user_id, useAttempt.attempt_id);

                return {
                    score: useAttempt.score,
                    time_played: _getTotalTimePlayed(studentScores),
                    completed: true,
                    sc_totals: this.getScoreCategoryTotalsForActInstUser(assignmentHash, attemptInfo.nova_act_inst_id, attemptInfo.user_hash)
                };
            }

            case Globals.assignment.score_types.LATEST: {
                useAttempt = maxBy(studentScores, attempt => parseInt(attempt.attempt_id, 10));
                attemptInfo = this.getAttemptForStudentAssignment(assignmentHash, useAttempt.user_id, useAttempt.attempt_id);

                return {
                    score: useAttempt.score,
                    time_played: _getTotalTimePlayed(studentScores),
                    completed: true,
                    sc_totals: this.getScoreCategoryTotalsForActInstUser(assignmentHash, attemptInfo.nova_act_inst_id, attemptInfo.user_hash)
                };
            }

            case Globals.assignment.score_types.AVG: {
                attemptInfo = this.getAttemptsForStudentAssignment(assignmentHash, studentId);
                const actInstIds = attemptInfo.map(attempt => attempt.nova_act_inst_id);
                const scTotals = this.getScoreCategoryTotalsForActInstsUser(assignmentHash, actInstIds, studentHash);
                const avgScTotals = _getAvgScTotals(scTotals);

                return {
                    score: _getAvgScore(studentScores),
                    time_played: _getTotalTimePlayed(studentScores),
                    completed: true,
                    sc_totals: avgScTotals
                };
            }
        }
    },

    getUserGroupings: function(assignmentHash) {
        var assignmentData = assignments[assignmentHash];

        if(!assignmentData) {
            console.warn("getAttemptForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        var userGroupings = {}

        forEach(assignments[assignmentHash]["activeAttempts"], (studentAttempt) => {
            // studentAttempt.role_id may not exist for assignments that do not yet have a multiplayer activity associated with them
            // if this is the case, this is not a valid, existing user grouping
            if(!!studentAttempt.user_id && !!studentAttempt.role_id) {
                if(!userGroupings[studentAttempt.id]) {
                    userGroupings[studentAttempt.id] = {
                        id: studentAttempt.id,
                        display_name: studentAttempt.name,
                        users: []
                    };
                }

                userGroupings[studentAttempt.id].users.push({
                    user_id: studentAttempt.user_id,
                    role_id: studentAttempt.role_id
                });
            }
        })


        return userGroupings;
    },

    getGameGroupingsUser: function(assignmentHash) {
        const assignmentData = assignments[assignmentHash];
        if (!assignmentData) {
            console.warn("getGameGroupingsUser: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        let gameGroupingsUser = {};
        forEach(assignmentData["allActiveAttempts"], (game) => {
            gameGroupingsUser[game.id] = {
                id: game.id,
                display_name: game.name,
                users: [],
            };

            const usersInGame = assignmentData["usersToAllActiveAttempts"][game.id];
            if (usersInGame) {
                gameGroupingsUser[game.id].users = usersInGame.map((u2attRecord) => {
                    return {
                        user_id: u2attRecord.user_id,
                        role_id: u2attRecord.role_id,
                    };
                });
            }
        });

        return gameGroupingsUser;
    },

    getGameGroupingsTeam: function(assignmentHash) {
        const assignmentData = assignments[assignmentHash];
        if (!assignmentData) {
            console.warn("getGameGroupingsTeam: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        let gameGroupingsTeam = {};
        forEach(assignmentData["allActiveAttempts"], (game) => {
            gameGroupingsTeam[game.id] = {
                id: game.id,
                display_name: game.name,
                teams: [],
            };

            const teamsInGame = assignmentData["teamsToAllActiveAttempts"][game.id];
            if (teamsInGame) {
                gameGroupingsTeam[game.id].teams = teamsInGame.map((team2attRecord) => {
                    return {
                        team_id: parseInt(team2attRecord.assignment_team_id, 10),
                        role_id: team2attRecord.act_role_id,
                    };
                });
            }
        });

        return gameGroupingsTeam;
    },

    getTeamGroupings: function(assignmentHash) {
        const assignmentData = assignments[assignmentHash];
        if (!assignmentData) {
            console.warn("getTeamGroupings: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        let teamGroupings = {};
        forEach(assignmentData["teams"], (team) => {
            teamGroupings[team.id] = {
                id: parseInt(team.id, 10),
                display_name: team.display_name,
                users: [],
            };

            team.users.forEach((userId) => {
                teamGroupings[team.id].users.push({
                    user_id: parseInt(userId, 10),
                    grp_id: 'students',
                });
            })
        });

        return teamGroupings;
    },

    getGames: function(assignmentHash) {
        var assignmentData = assignments[assignmentHash];

        if(!assignmentData) {
            console.warn("getAttemptForStudentAssignment: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        var games = {};

        forEach(assignments[assignmentHash]["activeAttempts"], (studentAttempt) => {
            if(!games[studentAttempt.id]) {
                games[studentAttempt.id] = {
                    name: studentAttempt.name,
                    nova_act_inst_id: studentAttempt.nova_act_inst_id
                }
            }
        })

        return sortBy(games, (g) => {return g.name});
    },

    getAssignmentActivityTraits: function(assignmentHash) {
        let assignmentData = assignments[assignmentHash];

        if(!assignmentData) {
            console.warn("getAssignmentActivityTraits: Assignment " + assignmentHash + " not found in store.");
            return {};
        }

        if(!assignmentData.activity) {
            console.warn("getAssignmentActivityTraits: Assignment " + assignmentHash + " activity not found in store.");
            return {};
        }

        if(!assignmentData.activity.traits) {
            console.warn("getAssignmentActivityTraits: Assignment " + assignmentHash + " activity traits not found in store.");
            console.log(assignmentData.activity);
            return {};
        }

        return assignmentData.activity.traits;
    },

    getAssignmentActivityRoles: function(assignmentHash) {
        if (!has(assignments, `${assignmentHash}.activity.roles`)) {
            console.warn("getAssignmentActivityRoles: Assignment " + assignmentHash + " assignment/activity/roles not found in store.");
        }

        return assignments[assignmentHash].activity.roles;
    },


    getAssignmentTurnInfoToDisplay: function(assignmentHash) {
        const assignment = get(assignments, `${assignmentHash}.assignment`, null);
        if (!assignment) {
            console.warn(`getAssignmentTurnInfoToDisplay: Assignment ${assignmentHash} not found in store.`);
            return null;
        }

        if (
            assignment.turn_type === Globals.assignment.turn_type.INSTRUCTOR_CONTROLLED
            || assignment.turn_type === Globals.assignment.turn_type.SCHEDULED
        ) {
            return {
                turn_ending: assignment.turn_ending,
                turn_current: assignment.turn_current,
                turn_length: assignment.turn_length,
                turn_type: assignment.turn_type,
                status: assignment.status,
                end_date: assignment.end_date,
            };
        }

        return null;
    },

    onResetAssnStoreStateCompleted: function(actionId) {
        this.resetState();
        action = { id: actionId };
        this.emitStatus();
    },
    
    onUpdateThirdPartyUserAccountInfoCompleted: function(actionId, userId, res) {
        forEach(assignments,(assignmentData,assignmentHash)=>{
            if (assignmentData.user && assignmentData.user.id == userId) {
                assignmentData.user.first_name = res.first_name;
                assignmentData.user.last_name = res.last_name;
                assignmentData.user.display_name = res.display_name;
            }
        });
        action = { id: actionId };
        this.emitStatus();
    },

    onUpdateThirdPartyUserAccountInfoFailed: function(actionId, userId, err) {
        console.log("onUpdateThirdPartyUserAccountInfoFailed error",err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null;
    },

    onError: function(actionId, err) {
        action = { id: actionId };
        if (err.status) {
            switch (err.status) {
                case 412:
                    action.error = new ForgeError({  message: "Students have not performed actions required for turn ending.", stack: null });
                    break;
                case 403:
                    action.error = new ForgeError({ message: err.responseText || ErrorConsts.FORBIDDEN, stack: null });
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
            }
        }
        else {
            action.error = err;
        }

        initialized = true;
        this.emitStatus();
    },

    onClearAssignmentCompleted: function(actionID) {
        assignments = [];
        this.emitStatus();
    },

    onClearAssignmentFailed: function(actionID) {
        console.log("onClearAssignmentFailed??");
    },

    onGetAssignmentCompleted: function(actionId, assignmentData) {
        // console.log("onGetAssignmentCompleted: ", actionId, assignmentData);
        action = { id: actionId };
        const assignmentHash = assignmentData.assignment.hash;
        if (isObject(assignments[assignmentHash])) delete assignments[assignmentHash]; //needed?
        
       // see if we have more than one page of information
        let currentStudentPage = 1;
        let numStudentPages = 1;
        let filterPages = 1;
        if (assignmentData.totalStudents >  assignmentData.students.length) {
            numStudentPages = Math.ceil(assignmentData.totalStudents / assignmentData.studentsPerPage);
            filterPages = Math.ceil(assignmentData.matchingStudents / assignmentData.studentsPerPage);
            currentStudentPage = assignmentData.studentPage;
        }

        assign(assignmentData,{
            currentStudentPage: currentStudentPage,
            numStudentPages: numStudentPages,
            filterPages: filterPages,
        });
        assignments[assignmentHash] = assignmentData;
        assignmentActivities[assignmentHash] = assignmentData.activity || null;
        initialized = true;
        loggedOutOfAssignment = false;

        if (get(assignmentData, 'externalData.integrationType') === Globals.integration_type.CONNECT) {
            InitPendo(assignmentData.externalData);
        }

        this.emitStatus();
    },

    onGetAssignmentFailed: function(actionID, err) {
        console.warn("onGetAssignmentFailed: ", actionID, err);
        console.log("err.status: " + err.status); // FIXME: remove debug spam
        if (err.status === 401) {
            action = { id: actionID, error: err };
            loggedOutOfAssignment = true;
            this.emitStatus();
            return;
        }
        this.onError(actionID, err);
    },

    onGetAssignmentActivityCompleted: function(actionId, assignmentHash, act) {
        action = { id: actionId };
        assignmentActivities[assignmentHash] = act || null; // interpret falsy server response as null
        this.emitStatus();
    },

    onGetAssignmentActivityFailed: function(actionId, assignmentHash, err) {
        console.log('onGetAssignmentActivityFailed', actionId, assignmentHash, err);
        this.onError(actionId, err);
    },

    onGetAssignmentTurnStatusCompleted: function(actionId, assignmentHash, assnTurnStatusObj) {
        action = { id: actionId };
        // get existing strurctures or create empty objects
        const existingAssignmentData = get(assignments, assignmentHash, {});
        const existingAssignment = get(assignments, `${assignmentHash}.assignment`, {});

        // merge assnTurnStatusObj res into existing
        assignments[assignmentHash] = {
            ...existingAssignmentData,
            assignment: {
                ...existingAssignment,
                ...assnTurnStatusObj,
            },
        };

        this.emitStatus();
    },

    onGetAssignmentTurnStatusFailed: function(actionId, assignmentHash, err) {
        console.log('onGetAssigmentTurnStatusFailed', actionId, assignmentHash, err);
        this.onError(actionId, err);
    },

   onAdminGetUserAssignmentsStarted: function(actionID, userId) {
        userAssignments.loading = true;
        userAssignments[userId] = null;
        this.emitStatus();
   },

   onAdminGetUserAssignmentsCompleted: function(actionID, userId, assignmentData) {
        // console.log("onAdminGetUserAssignmentsCompleted: ", actionID, assignmentData);
        action.id = actionID;
        userAssignments.loading = false;
        userAssignments[userId] = assignmentData;
        this.emitStatus();
    },

    onAdminGetUserAssignmentsFailed: function(actionID, userId, err) {
        console.warn("onAdminGetUserAssignmentsFailed: ", actionID, err);
        userAssignments.loading = false;
        userAssignments[userId] = null;
        this.emitStatus();
        this.onError(actionID, err);
    },

   onAdminGetStudentCountPerIntegrationTypeStarted: function(actionID, userId) {
        userAssignmentStudentCounts.loading = true;
        userAssignmentStudentCounts[userId] = null;
        this.emitStatus();
   },

   onAdminGetStudentCountPerIntegrationTypeCompleted: function(actionID, userId, data) {
        // console.log("onAdminGetStudentCountPerIntegrationTypeCompleted: ", actionID, data);
        action.id = actionID;
        userAssignmentStudentCounts.loading = false;
        userAssignmentStudentCounts[userId] = data;
        this.emitStatus();
    },

    onAdminGetStudentCountPerIntegrationTypeFailed: function(actionID, userId, err) {
        console.warn("onAdminGetStudentCountPerIntegrationTypeFailed: ", actionID, err);
        userAssignmentStudentCounts.loading = false;
        userAssignmentStudentCounts[userId] = null;
        this.emitStatus();
        this.onError(actionID, err);
    },

    onPlayAssignmentCompleted: function(actionID, assignmentHash, playInfoObj) {
        // console.log("onPlayAssignmentCompleted: ", actionID, playUrl);
        action = { id: actionID };

        if(!isObject(assignments[assignmentHash])) assignments[assignmentHash] = {}; //probably shouldn't need this
        assignments[assignmentHash].playUrl = playInfoObj.playUrl;
        assignments[assignmentHash].allowPlay = playInfoObj.allowPlay;
        assignments[assignmentHash].playMessage = playInfoObj.message;

        // initialized = true;

        this.emitStatus();
    },

    onPlayAssignmentFailed: function(actionID, err) {
        console.warn("onPlayAssignmentFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onSetupAssignmentCompleted: function(actionID, assignmentHash, res) {
        // console.log("onSetupAssignmentCompleted: ", actionID, res);
        action.id = actionID;
        assignments[assignmentHash].assignment = res.assignment;
        assignments[assignmentHash].activity = res.activity;

        //optional return values.
        if(!!res.activeAttempts) {
            assignments[assignmentHash].activeAttempts = res.activeAttempts;
        }

        if(!!res.attempts) {
            assignments[assignmentHash].attempts = res.attempts;
        }

        if(!!res.turnDates) {
            assignments[assignmentHash].turnDates = res.turnDates;
        }

        initialized = true;

        this.emitStatus();
    },

    onSetupAssignmentFailed: function(actionID, err) {
        console.warn("onSetupAssignmentFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onForceEndTurnCompleted: function(actionId, assignmentId, res) {
        // console.log("onForceEndTurnCompleted:", actionID, assignmentId, res);
        action = { id: actionId };
        this.emitStatus();
    },

    onForceEndTurnFailed: function(actionId, assignmentId, err) {
        console.warn("onForceEndTurnFailed:", actionId, assignmentId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetupConnectAssignmentActivityCompleted: function(actionID, assignmentHash, res) {
        console.log("onSetupConnectAssignmentActivityCompleted: ", actionID, assignmentHash, res);
        action.id = actionID;
        assignments[assignmentHash].forwardUrl = res;

        this.emitStatus();
    },

    onSetupConnectAssignmentActivityFailed: function(actionID, err) {
        console.warn("onSetupConnectAssignmentActivityFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onSetupConnectAssignmentPolicyCompleted: function(actionId, assignmentHash, res) {
        console.log("onSetupConnectAssignmentPolicyCompleted: ", actionId, assignmentHash, res);
        action = { id: actionId };
        assignments[assignmentHash].forwardUrl = res;
        this.emitStatus();
    },

    onSetupConnectAssignmentPolicyFailed: function(actionId, assignmentHash, err) {
        console.warn("onSetupConnectAssignmentPolicyFailed: ", actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    _appendToAdminSendScoreErrors(assignmentHash, attemptId, studentId, additionalParams={}) { // replace/update if record exists
        if (!adminSendScoreErrors) adminSendScoreErrors = [];

        let replaced = false;
        adminSendScoreErrors = adminSendScoreErrors.map((errorRecord) => {
            if (
                errorRecord.assignment_hash === assignmentHash
                && errorRecord.attempt_id === attemptId
                && errorRecord.user_id === studentId
            ) {
                replaced = true;
                return { ...errorRecord, ...additionalParams };
            }
            else {
                return errorRecord;
            }
        });

        if (!replaced) {
            adminSendScoreErrors.push({
                assignment_hash: assignmentHash,
                attempt_id: attemptId,
                user_id: studentId,
                ...additionalParams,
            });
        }
    },

    onResendConnectAssignmentScoreCompleted: function(actionId, assignmentHash, attemptId, studentId, res) {
        console.log('onResendConnectAssignmentScoreCompleted:', actionId, assignmentHash, attemptId, studentId, res);
        action = { id: actionId };
        this._appendToAdminSendScoreErrors(assignmentHash, attemptId, studentId, { resend_success: true });
        this.emitStatus();
    },

    onResendConnectAssignmentScoreFailed: function(actionId, assignmentHash, attemptId, studentId, err) {
        console.warn('onResendConnectAssignmentScoreFailed:', actionId, assignmentHash, attemptId, studentId, err);
        action = { id: actionId, error: err };
        this._appendToAdminSendScoreErrors(assignmentHash, attemptId, studentId, { error_message: StringUtil.stringifyError(err) });
        this.emitStatus();
    },

    onResendVantageAssignmentScoreCompleted: function(actionId, assignmentHash, attemptId, studentId, res) {
        console.log('onResendVantageAssignmentScoreCompleted:', actionId, assignmentHash, attemptId, studentId, res);
        action = { id: actionId };
        this._appendToAdminSendScoreErrors(assignmentHash, attemptId, studentId, { resend_success: true });
        this.emitStatus();
    },

    onResendVantageAssignmentScoreFailed: function(actionId, assignmentHash, attemptId, studentId, err) {
        console.warn('onResendVantageAssignmentScoreFailed:', actionId, assignmentHash, attemptId, studentId, err);
        action = { id: actionId, error: err };
        this._appendToAdminSendScoreErrors(assignmentHash, attemptId, studentId, { error_message: StringUtil.stringifyError(err) });
        this.emitStatus();
    },

    onSubmitMultiActivityAssignmentAttemptCompleted: function(actionId, assignmentHash, attemptNum, assignmentData) {
        console.log('onSubmitMultiActivityAssignmentAttemptCompleted:', actionId, assignmentHash, attemptNum, assignmentData);
        action = { id: actionId };
        // do the same thing as onGetAssignmentCompleted
        if (isObject(assignments[assignmentHash])) delete assignments[assignmentHash]; //needed?
        
       // see if we have more than one page of information
        let currentStudentPage = 1;
        let numStudentPages = 1;
        let filterPages = 1;
        if (assignmentData.totalStudents >  assignmentData.students.length) {
            numStudentPages = Math.ceil(assignmentData.totalStudents / assignmentData.studentsPerPage);
            filterPages = Math.ceil(assignmentData.matchingStudents / assignmentData.studentsPerPage);
            currentStudentPage = assignmentData.studentPage;
        }

        assign(assignmentData,{
            currentStudentPage: currentStudentPage,
            numStudentPages: numStudentPages,
            filterPages: filterPages,
        });
        assignments[assignmentHash] = assignmentData;
        assignmentActivities[assignmentHash] = assignmentData.activity || null;
        initialized = true;
        loggedOutOfAssignment = false;

        this.emitStatus();
    },

    onSubmitMultiActivityAssignmentAttemptFailed: function(actionId, assignmentHash, attemptNum, err) {
        console.warn('onSubmitMultiActivityAssignmentAttemptFailed:', actionId, assignmentHash, attemptNum, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddAssignmentAdminCompleted: function(actionId, assignmentHash, res) {
        // console.log('onAddAssignmentAdminCompleted:', actionId, assignmentHash, res);
        action = { id: actionId };
        this.emitStatus();
    },

    onAddAssignmentAdminFailed: function(actionId, assignmentHash, err) {
        console.warn('onAddAssignmentAdminFailed:', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssignmentWeightsCompleted: function(actionId, assignmentHash, weights) {
        // console.log('onGetAssignmentWeightsCompleted', actionId, assignmentHash, weights);
        action = { id: actionId };
        assignmentWeights[assignmentHash] = weights;
        this.emitStatus();
    },

    onGetAssignmentWeightsFailed: function(actionId, assignmentHash, err) {
        console.warn('onGetAssignmentWeightsFailed', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssignmentMetaOptionsCompleted: function(actionId, assignmentHash, metaOptions) {
        // console.log('onGetAssignmentMetaOptionsCompleted', actionId, assignmentHash, metaOptions);
        action = { id: actionId };
        assignmentMetaOptions[assignmentHash] = metaOptions;
        this.emitStatus();
    },

    onGetAssignmentMetaOptionsFailed: function(actionId, assignmentHash, err) {
        console.warn('onGetAssignmentMetaOptionsFailed', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetLtiDiagnosticsCompleted: function(actionId, assignmentHash, res) {
        // console.log('onGetLtiDiagnosticCompleted', actionId, assignmentHash, res);
        action = { id: actionId };
        assignmentLtiDiagnostics[assignmentHash] = res;
        this.emitStatus();
    },

    onGetLtiDiagnosticsFailed: function(actionId, assignmentHash, err) {
        console.warn('onGetLtiDiagnosticFailed', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetSectionRosterCompleted: function(actionId, assignmentHash, res) {
        console.log("onGetSectionRosterCompleted: ", actionId, assignmentHash, res);
        action = { id: actionId };
        if (!isObject(assignments[assignmentHash])) assignments[assignmentHash] = {};
        assignments[assignmentHash].students = res;
        assign( // full assignment roster is returned from this endpoint
            assignments[assignmentHash],
            {
                currentStudentPage: 1,
                numStudentPages: 1,
                filterPages: 1,
            }
        );

        this.emitStatus();
    },

    onGetSectionRosterFailed: function(actionId, assignmentHash, err) {
        console.warn("onGetSectionRosterFailed: ", actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetUserAttemptHistoryCompleted: function(actionId, assignmentHash, userAttemptId, res) {
        action = { id: actionId };
        userAttemptHistories[userAttemptId] = res;
        this.emitStatus();
    },

    onGetUserAttemptHistoryFailed: function(actionId, assignmentHash, userAttemptId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminSendScoresErrorsCompleted: function(actionId, sendScoreErrors) {
        // console.log('onGetAdminSendScoresErrorsCompleted', actionId, sendScoreErrors);
        action = { id: actionId };
        adminSendScoreErrors = sendScoreErrors;
        this.emitStatus();
    },

    onGetAdminSendScoresErrorsFailed: function(actionId, err) {
        console.warn('onGetAdminSendScoresErrorsFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminSendScoresErrorCompleted: function(actionId, userAttemptId, sendScoreError) {
        // console.log('onGetAdminSendScoresErrorCompleted', actionId, userAttemptId, sendScoreErrors);
        action = { id: actionId };
        let replaced = false;
        adminSendScoreErrors = adminSendScoreErrors.map((error) => {
            if (error.user_attempt_id === userAttemptId) {
                replaced = true;
                return sendScoreError;
            }

            return error;
        });

        if (!replaced) {
            adminSendScoreErrors.push(sendScoreError);
        }

        adminSendScoreErrors = compact(adminSendScoreErrors); // covers sendScoreError = null (score sent successfully -> remove)

        this.emitStatus();
    },

    onGetAdminSendScoresErrorFailed: function(actionId, userAttemptId, err) {
        console.warn('onGetAdminSendScoresErrorFailed', actionId, userAttemptId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = AssignmentStore;
